// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Message.css */

/* General style for message container */
.message {
    font-size: 14px;
    margin-top: 5px;
    padding: 10px;
    border-radius: 5px;
    width: 100%;
    text-align: center;
  }
  
  /* Success message */
  .message.success {
    color: green;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
  }
  
  /* Error message */
  .message.error {
    color: red;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
  }
  
  /* Loading message */
  .message.loading {
    color: orange;
    background-color: #fff3cd;
    border: 1px solid #ffeeba;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/message.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,wCAAwC;AACxC;IACI,eAAe;IACf,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA,oBAAoB;EACpB;IACE,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB;IACE,UAAU;IACV,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,yBAAyB;IACzB,yBAAyB;EAC3B","sourcesContent":["/* Message.css */\n\n/* General style for message container */\n.message {\n    font-size: 14px;\n    margin-top: 5px;\n    padding: 10px;\n    border-radius: 5px;\n    width: 100%;\n    text-align: center;\n  }\n  \n  /* Success message */\n  .message.success {\n    color: green;\n    background-color: #d4edda;\n    border: 1px solid #c3e6cb;\n  }\n  \n  /* Error message */\n  .message.error {\n    color: red;\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n  }\n  \n  /* Loading message */\n  .message.loading {\n    color: orange;\n    background-color: #fff3cd;\n    border: 1px solid #ffeeba;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
